import * as imageConversion from 'image-conversion'
import bus from '@/utils/bus'
export function beforeUpload(file) {




    return new Promise((resolve, reject) => {
        if (!(file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png')) {
            this.$message({ type: 'error', message: '图片格式目前只支持 jpg,jpeg 和 png' })
            reject(new Error('图片格式目前只支持'))
        }
        console.log('bbbbbbbbbbbbbbbbb')
        console.log(file)
        // 验证图片真实格式
        const message = this.$message
        let realMimeType
        const reader = new FileReader()

        // running asynchronously!
        reader.onloadend = function () {
            const arr = new Uint8Array(reader.result).subarray(0, 4)
            let header = ''
            for (const item of arr) {
                header += item.toString(16)
            }
            console.log(header)

            // 在这里可以得到上传图片的真实mintype类型
            // 在这里执行你的逻辑，该方法是异步执行
            //  const fname = file.name.substring(0, file.name.lastIndexOf('.'))
            console.log(file)
            if (header.indexOf('8950') === 0) {
                realMimeType = 'png'
                file.realType = realMimeType
            } else if (header.indexOf('ffd8') === 0) {
                realMimeType = 'jpg'
                file.realType = realMimeType
            } else {
                realMimeType = 'unknown'
                //   console.log('ssssssssssss')
                message({ type: 'error', message: '图片类型与文件类型不匹配,请上传其他图片,图片格式目前只支持 jpg, 和 png' })
                reject(new Error('图片类型与文件类型不匹配,请上传其他图片,图片格式目前只支持 jpg, 和 png'))
                // 不处理实际类型 
                return;
            }

            realMimeType = file.name.substring(file.name.lastIndexOf('.'), file.name.lenght)
            // console.log('jjj   ==== ' + realMimeType)
            console.log(file)
            // 处理进一步
            const _URL = window.URL || window.webkitURL
            const image = new Image()
            image.src = _URL.createObjectURL(file)

            image.onload = function () {
                // 检查图片宽度或高度不超过4096
                if (image.width > 4096 || image.height > 4096) {
                    message({ type: 'error', message: '图片宽度或高度不能超过4096像素' })
                    reject(new Error('图片宽度或高度不能超过4096像素'))
                    return;
                }

                // 继续其他处理
                const isLt2M = file.size / 1024 / 1024 < 3 // 图片大小限制
                if (isLt2M) {
                    bus.$emit('imgSize', image.width, image.height)
                    resolve(file)
                } else {
                    imageConversion.compressAccurately(file, 1024).then(res => { // 压缩图片
                        console.log(' 图片成功')
                        const _URL = window.URL || window.webkitURL
                        const compressedImage = new Image()
                        compressedImage.src = _URL.createObjectURL(res)
                        compressedImage.onload = function () {
                            console.log(compressedImage.width, compressedImage.height)
                            bus.$emit('imgSize', compressedImage.width, compressedImage.height)
                        }
                        resolve(res)
                    }).catch(err => {
                        console.log(err.message + ' 图片压缩失败')
                        reject(err)
                    })
                }
            }

            image.onerror = function () {
                message({ type: 'error', message: '图片加载失败，请上传有效图片' })
                reject(new Error('图片加载失败，请上传有效图片'))
            }
        }
        reader.readAsArrayBuffer(file)
    })

}

// 将图片压缩到指定尺寸 
// export function mattingImgUpload1(file) {


// }

export function mattingImgUpload(file) {


    const maxWidth = 1024
    const maxHeight = 1024

    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = function (event) {
            const img = new Image()

            img.onload = function () {
                const canvas = document.createElement('canvas')
                let width = img.width
                let height = img.height
                if (width <= 1024 && height <= 1024) {
                    resolve(file)
                    return
                }

                // 保持图片宽高比，同时不超过指定的最大宽度和高度  
                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width
                        width = maxWidth
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height
                        height = maxHeight
                    }
                }

                canvas.width = width
                canvas.height = height

                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)

                // 将Canvas内容转换为Blob对象（如果需要File对象，可以使用后续步骤进一步处理）  
                canvas.toBlob(function (blob) {
                    resolve(blob) // 或者你可以根据需要返回Data URL、File对象等  
                }, 'image/png', 0.8) // 第三个参数是JPEG图片的质量，范围从0到1  
            }

            img.src = event.target.result
        }

        reader.readAsDataURL(file)
    })
}



//   接受一个image对象 检查图片大小不能超过10m  
export function checkImgSize(file) {

    return new Promise((resolve, reject) => {
        if (!(file.type == 'image/jpg' || file.type == 'image/png' || file.type == 'image/jpeg')) {
            this.$message({ type: 'error', message: '图片格式目前只支持 jpg, 和 png' })
            reject(new Error('图片格式目前只支持'))


        }
        // 读取图片真实 类型
        let realMimeType
        const message = this.$message
        const reader = new FileReader()
        // running asynchronously!
        reader.onloadend = function () {
            const arr = new Uint8Array(reader.result).subarray(0, 4)
            let header = ''
            for (const item of arr) {
                header += item.toString(16)
            }
            console.log(header)

            // 在这里可以得到上传图片的真实mintype类型
            // 在这里执行你的逻辑，该方法是异步执行
            if (header.indexOf('8950') === 0) {
                realMimeType = 'png'

            } else if (header.indexOf('ffd8') === 0) {
                realMimeType = 'jpeg'
            } else {
                realMimeType = 'unknown'
                reject(new Error('图片类型与文件类型不匹配,请上传其他图片'))
            }
            console.log(realMimeType)

            // 处理进一步
            const _URL = window.URL || window.webkitURL
            const image = new Image()
            image.src = _URL.createObjectURL(file)

            image.onload = function () {
                if (image.width > 1024 && image.height > 1024) {
                    message({ type: 'error', message: '图片大小不能超过10M,宽高不能超过1024*1024' })
                    reject(new Error('图片大小不能超过10M,宽高不能超过1024*1024'))
                }
                if (image.width <= 1024 && image.height / image.width > 2) {
                    reject(new Error('宽高不能超过1024*1024,宽高比不能超过2倍'))
                }
                if (image.height >= 1024 && image.width / image.height > 2) {
                    reject(new Error('宽高不能超过1024*1024,宽高比不能超过2倍'))
                }
                if (file.size / 1024 / 1024 < 10) {
                    resolve(file)
                } else {
                    message({ type: 'error', message: '图片大小不能超过10M,宽高不能超过1024*1024' })
                    reject(new Error('图片大小不能超过10M,宽高不能超过1024*1024'))
                }
            }

        }
        reader.readAsArrayBuffer(file)


    })
}

export function getUploadThumb(url, size) {
    // 区分是那个服务器的 

    if (url.indexOf('oss') > -1) {
        if (url.indexOf('?') > -1) {
            return url
        } else {
            return url + '?x-oss-process=image/resize,l_' + size
        }
    } else {
        if (url.indexOf('?') > -1) {
            return url
        } else {
            return url + '?imageMogr2/thumbnail/' + size + 'x/format/webp'
        }
    }


}

export function checkRealMimeType(file, callback) {
    let realMimeType
    const reader = new FileReader()
    // running asynchronously!
    reader.onloadend = function () {
        const arr = new Uint8Array(reader.result).subarray(0, 4)
        let header = ''
        for (const item of arr) {
            header += item.toString(16)
        }
        console.log(header)
        // 在这里可以得到上传图片的真实mintype类型
        // 在这里执行你的逻辑，该方法是异步执行
        if (header.indexOf('8950') === 0) {
            realMimeType = 'png'
        } else if (header.indexOf('ffd8') === 0) {
            realMimeType = 'jpeg'
        } else if (header.indexOf('4749') === 0) {
            realMimeType = 'gif'
        } else if (header.indexOf('424d') === 0) {
            realMimeType = 'bmp'
        } else {
            realMimeType = 'unknown'
        }
        console.log(realMimeType)
        $('#header').text(header)
        $('#realMimeType').text(realMimeType)
    }
    reader.readAsArrayBuffer(file)
}



// WEBPACK FOOTER //
// ./src/utils/imgtool.js